// Location Popup
document.addEventListener("DOMContentLoaded", function() {
  var modal = document.getElementById("locationModal");
  var closeBtn = document.querySelector(".close-modal");

  // All links with this class will open the modal
  var triggers = document.querySelectorAll(".open-location-modal");
  
  triggers.forEach(function(trigger) {
    trigger.addEventListener("click", function(e) {
      e.preventDefault();
      modal.style.display = "flex";
    });
  });

  // Close modal on X
  closeBtn.addEventListener("click", function() {
    modal.style.display = "none";
  });

  // Close modal on outside click
  window.addEventListener("click", function(e) {
    if (e.target === modal) {
      modal.style.display = "none";
    }
  });
});
// Location Popup End


// Read more button for Product description 
document.addEventListener("DOMContentLoaded", () => {
    if (document.getElementById("see-more-btn")) {
        const content = document.getElementById("see-more-content");
        const btn = document.getElementById("see-more-btn");

        btn.onclick = () => {
            content.classList.toggle("expanded");
            btn.textContent = content.classList.contains("expanded") ? "See less" : "See more";
        };
    }
});
// End Read more button for Product description 


// Shop filter Popup
// document.addEventListener("DOMContentLoaded", function() {
//   const bar = document.querySelector(".collection-filter-bar");
//   const toggleBtn = bar.querySelector(".filter-btn");
//   const popup = bar.querySelector(".filter-popup");
//   const closeBtn = bar.querySelector(".filter-close");
//   const resetBtn = bar.querySelector(".filter-reset");

//   // Toggle popup
//   toggleBtn.addEventListener("click", () => {
//     popup.classList.toggle("active");
//   });

//   // Close button
//   closeBtn.addEventListener("click", () => {
//     popup.classList.remove("active");
//   });

//   // Reset filters
//   resetBtn.addEventListener("click", () => {
//     popup.querySelectorAll("input[type=radio]").forEach(r => r.checked = false);
//   });

//   // Close if clicked outside
//   document.addEventListener("click", (e) => {
//     if (!bar.contains(e.target)) {
//       popup.classList.remove("active");
//     }
//   });
// });



// From equalheight Js code
$(function ($) {
    $(window).on('load',function() {
        equalheight('.product-card__title');
        equalheight('.price-wrap');
    });
    $(window).on('resize',function() {
        equalheight('.product-card__title');
        equalheight('.price-wrap');
    });
}); 


